import { render, staticRenderFns } from "./RelayBox.vue?vue&type=template&id=12ee8f6a&"
import script from "./RelayBox.vue?vue&type=script&lang=ts&"
export * from "./RelayBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports